import {
  GET_FEEDS_STATUS,
  RUN_FEED,
  UPDATE_FEED_STATUS,
  GET_FEEDS_FOR_DATE,
  RUN_FEED_WITH_COMMENTS,
  LOAD_FEED_SCHEDULE_ID,
  GET_FEED_BREAKDOWN_INFO,
  GET_AUDIT_BREAKDOWN_INFO,
  STORE_FEED_BREAKDOWN_AUDIT_ID,
  GET_FEED_ERROR_DETAILS,
  DOWNLOAD_FEED_ERROR,
  CHECK_IF_FEED_REPORT_AVAILABLE,
  DOWNLOAD_FEED_ERROR_REPORT_CSV,
  GET_FEED_SPECIFIC_DETAILS
} from '../action-types'
import {
  SET_FEED_ACTIVE_TOGGLE, SET_FEEDS_STATUS,
  SET_INFORMATION_SNACKBAR_STATE,
  SET_INFORMATION_SNACKBAR_TEXT,
  SET_FEED_BREAKDOWN_INFO,
  SET_AUDIT_BREAKDOWN_INFO,
  SET_FEED_BREAKDOWN_LOADING,
  SET_FEED_BREAKDOWN_LIST_SCROLL_TOP,
  SET_FEED_BREAKDOWN_ID,
  SET_FEED_BREAKDOWN_DATE_FILTER_CHANGE,
  CLEAR_FEED_BREAKDOWN_RESULTS,
  SET_FEED_BREAKDOWN_PROCESS_DATE_CHANGE,
  SET_FEED_BREAKDOWN_AUDIT_ID,
  SET_FEED_CARD_DATA,
  SET_FEED_SCHEDULE_ID,
  SET_FEED_BREAKDOWN_SHOW_STATE,
  SET_FEED_AUDIT_LOADING,
  SET_FEED_ERROR_DETAILS,
  RESET_FEED_DETAILS_DATE_RANGE,
  SET_FEED_ERROR_DETAILS_LOADING,
  FEED_REPORT_LOADING_LABEL,
  FEED_REPORT_FINISHED_LABEL,
  FEED_REPORT_LOADING
} from '../mutation-types'
import {informationTexts} from './information'
import server from '../server'
import axios from 'axios/index'
import moment from 'moment-es6'
import FileSaver from 'file-saver'

const state = {
  feedStatus: [],
  breakdownInfos: [],
  // breakdownAuditInfos: [],
  // breakdown filters, loader, etc
  scheduleId: 0,
  processId: 0,
  isLoading: false,
  requestFromDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
  requestToDate: moment().format('YYYY-MM-DD'),
  filters: 'all',
  processDate: '',
  pageNumber: 0,
  pageSize: 20,
  sortBy: 'ID',
  ascDesc: 'DESC',
  // card feed info
  scheduledAt: '',
  offsetDays: 0,
  requiredEngagement: false,
  // pagination
  currentPage: -1,
  totalElements: 0,
  lastPage: false,
  scrollTop: 0,
  // detail audit table
  requestId: 0,
  auditLoading: {},
  feedErrorDetails: [],
  isErrorDetailsLoading: false,
  report_download_button_label: 'feeds.report_download',
  report_downloading: false
}

const mutations = {
  [SET_FEED_BREAKDOWN_SHOW_STATE] (state, id) {
    const feedBreakdownInfo = state.breakdownInfos.find(int => int.id === id)
    feedBreakdownInfo.isOpen = !feedBreakdownInfo.isOpen
  },
  [SET_FEEDS_STATUS] (state, status) {
    state.feedStatus = status
  },
  [SET_FEED_ACTIVE_TOGGLE] (state, feedToggle) {
    state.feedStatus.filter(fl => fl.scheduleId === feedToggle.feed.scheduleId)[0].processActive = feedToggle.active
    if (!feedToggle.active && feedToggle.feed.requiredEngagement) {
      state.feedStatus.filter(fl => fl.processId === 'ENGAGEMENT_SCORES')[0].processActive = feedToggle.active
    }
  },
  [SET_FEED_BREAKDOWN_INFO] (state, loadState) {
    state.breakdownInfos = state.breakdownInfos.concat(loadState.breakdownInfos.map(breakdownInfo => {
      breakdownInfo.isOpen = false
      breakdownInfo.processAudits = []
      return breakdownInfo
    }))
    state.totalElements = loadState.totalElements
    state.isLoading = false
    state.currentPage += 1
    state.lastPage = loadState.lastPage
  },
  [SET_AUDIT_BREAKDOWN_INFO] (state, loadState) {
    const feedBreakdown = state.breakdownInfos.find(int => int.id === state.requestId)
    feedBreakdown.processAudits = loadState
  },
  [SET_FEED_ERROR_DETAILS] (state, feedErrorDetails) {
    state.feedErrorDetails = feedErrorDetails
  },
  [SET_FEED_BREAKDOWN_LOADING] (state, loading) {
    state.isLoading = loading
  },
  [SET_FEED_ERROR_DETAILS_LOADING] (state, loading) {
    state.isErrorDetailsLoading = loading
  },
  [SET_FEED_AUDIT_LOADING] (state, {state: loadingState, requestId}) {
    state.auditLoading = {
      ...state.auditLoading,
      [requestId]: loadingState
    }
  },
  [SET_FEED_BREAKDOWN_LIST_SCROLL_TOP] (state, scrollTop) {
    state.scrollTop = scrollTop
  },
  [SET_FEED_BREAKDOWN_ID] (state, scheduleId) {
    state.scheduleId = scheduleId
    state.breakdownInfos = []
    state.lastPage = false
    state.currentPage = -1
    state.requestFromDate = moment().subtract(7, 'days').format('YYYY-MM-DD')
    state.requestToDate = moment().format('YYYY-MM-DD')
    state.processDate = ''
  },
  [SET_FEED_BREAKDOWN_AUDIT_ID] (state, requestId) {
    state.requestId = requestId
    state.breakdownAuditInfos = []
  },
  [SET_FEED_BREAKDOWN_DATE_FILTER_CHANGE] (state, filters) {
    if (filters.startDate) {
      state.requestFromDate = filters.startDate
      state.requestToDate = filters.endDate
    }
  },
  [RESET_FEED_DETAILS_DATE_RANGE] (state) {
    state.requestFromDate = moment().subtract(7, 'days').format('YYYY-MM-DD')
    state.requestToDate = moment().format('YYYY-MM-DD')
  },
  [CLEAR_FEED_BREAKDOWN_RESULTS] (state) {
    state.breakdownInfos = []
    state.lastPage = false
    state.currentPage = -1
  },
  [SET_FEED_BREAKDOWN_PROCESS_DATE_CHANGE] (state, value) {
    state.processDate = value
  },
  [SET_FEED_SCHEDULE_ID] (state, scheduleId) {
    state.breakdownInfos = []
    state.lastPage = false
    state.currentPage = -1
    state.scheduleId = scheduleId
  },
  [SET_FEED_CARD_DATA]  (state, feed) {
    state.scheduledAt = moment(feed.nextTriggerDate).format('hh:mm')
    state.offsetDays = feed.processScheduleOffsetDays
    state.requiredEngagement = feed.requiredEngagement
    state.scheduleId = feed.scheduleId
    state.processId = feed.processId
  },
  [FEED_REPORT_LOADING_LABEL] (state) {
    state.report_download_button_label = 'feeds.report_download_in_progress'
  },
  [FEED_REPORT_FINISHED_LABEL] (state) {
    state.report_download_button_label = 'feeds.report_download'
  },
  [FEED_REPORT_LOADING] (state, value) {
    state.report_downloading = value
  }
}

let getFeedBreakdownAuditInfo = function (context, actionData) {
  return server.postReplayable(`/core/connect/feed/filter/breakdown`, {
    processAuditRequestId: context.state.requestId,
    feedStatus: 'all' // TODO: needs to be handled for filtering
  }, actionData)
}

let getFeedBreakdownInfo = function (context, actionData) {
  return server.postReplayable('/core/connect/feed/filter', {
    scheduleId: context.state.scheduleId,
    pageNumber: context.state.currentPage + 1,
    pageSize: context.state.pageSize,
    ascDesc: context.state.ascDesc,
    sortBy: context.state.sortBy,
    requestFromDate: context.state.requestFromDate,
    requestToDate: context.state.requestToDate,
    processDate: context.state.processDate,
    feedStatus: 'all' // TODO: needs to be handled
  }, actionData)
}

const actions = {
  [GET_FEEDS_STATUS] ({commit}, forDate) {
    const actionData = { action: GET_FEEDS_STATUS, data: forDate }
    server.getReplayable(`/core/connect/${forDate}`, actionData).then(response => {
      commit(SET_FEEDS_STATUS, response.data)
    })
    .catch(error => {
      console.log('Cannot retrieve feeds')
      console.log(error)
    })
  },
  [GET_FEEDS_FOR_DATE] ({commit}, forDate) {
    const actionData = { action: GET_FEEDS_FOR_DATE, data: forDate }
    server.getReplayable(`/core/connect/get/${forDate}`, actionData).then(response => {
      commit(SET_FEEDS_STATUS, response.data)
    })
      .catch(error => {
        console.log('Cannot retrieve feeds for the given date')
        console.log(error)
      })
  },
  [RUN_FEED] ({commit, dispatch, state}, {processId, scheduleId, date, fromDate}) {
    const processScheduleId = processId + scheduleId
    const actionData = { action: RUN_FEED, data: { processId, scheduleId, date } }
    let targetUrl
    if (fromDate === null) {
      targetUrl = `/core/connect/run/${processScheduleId}`
    } else {
      targetUrl = `/core/connect/run/${processScheduleId}/${fromDate}`
    }
    server.getReplayable(targetUrl, actionData).then(response => {
      const runningProcessScheduleId = response.data
      let infoKey
      if (runningProcessScheduleId.length === 0) {
        infoKey = informationTexts.FEED_UNABLE
      } else {
        infoKey = (runningProcessScheduleId === processScheduleId)
                ? informationTexts.FEED_STARTED : informationTexts.FEED_ALREADY_RUNNING
        dispatch(GET_FEEDS_FOR_DATE, date)
      }
      commit(SET_INFORMATION_SNACKBAR_TEXT, infoKey)
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
    })
  },
  async [RUN_FEED_WITH_COMMENTS] ({rootState, state, dispatch, commit}, payload) {
    const processScheduleId = payload.processId + payload.scheduleId
    let targetUrl
    if (payload.fromDate === null) {
      targetUrl = `core/connect/run/comment/${processScheduleId}`
    } else {
      targetUrl = `core/connect/run/comment/${processScheduleId}/${payload.fromDate}`
    }
    await axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/${targetUrl}`,
      method: 'post',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      data: payload,
      actionData: { action: RUN_FEED_WITH_COMMENTS, data: payload }
    })
      .then((response) => {
        const runningProcessScheduleId = response.data
        let infoKey
        if (runningProcessScheduleId.length === 0) {
          infoKey = informationTexts.FEED_UNABLE
        } else {
          infoKey = (runningProcessScheduleId === processScheduleId)
            ? informationTexts.FEED_STARTED : informationTexts.FEED_ALREADY_RUNNING
          dispatch(GET_FEEDS_FOR_DATE, payload.date)
        }
        commit(SET_INFORMATION_SNACKBAR_TEXT, infoKey)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
      })
      .catch((err) => {
        console.log('Failed to re-run feed with comments')
        console.error(err)
      })
  },
  [UPDATE_FEED_STATUS] ({rootState, state, commit}, {scheduleId, active}) {
    const payload = { scheduleId, active }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/connect/active/${scheduleId}/${active}`,
      method: 'put',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: UPDATE_FEED_STATUS, data: payload}
    }).then((res) => {
      if (active) {
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.FEED_ACTIVATED)
      } else {
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.FEED_DEACTIVATED)
      }
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
    }).catch((err) => {
      console.log('Failed to activate/deactivate feed')
      console.error(err)
    })
  },
  [GET_FEED_SPECIFIC_DETAILS] ({rootState, state, commit}, scheduleId) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/connect/feed/details/${scheduleId}`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: GET_FEED_SPECIFIC_DETAILS}
    }).then((res) => {
      commit(SET_FEED_CARD_DATA, res.data)
    }).catch((err) => {
      console.log('Failed to get feed information')
      console.error(err)
    })
  },
  [GET_FEED_BREAKDOWN_INFO] (context) {
    const actionData = {action: GET_FEED_BREAKDOWN_INFO}
    if (context.state.isLoading || context.state.lastPage) {
      return Promise.resolve()
    }
    return new Promise((resolve, reject) => {
      context.commit(SET_FEED_BREAKDOWN_LOADING, true)
      getFeedBreakdownInfo(context, actionData)
          .then(result => {
            let data = {
              breakdownInfos: result.data.content,
              totalElements: result.data.totalElements,
              lastPage: result.data.last
            }
            context.commit(SET_FEED_BREAKDOWN_INFO, data)
            context.commit(SET_FEED_BREAKDOWN_LOADING, false)
            resolve(data)
          })
          .catch((err) => {
            console.error('Error fetching feeds', err)
            context.commit(SET_FEED_BREAKDOWN_LOADING, false)
            reject(err)
          })
    })
  },
  [GET_AUDIT_BREAKDOWN_INFO] (context) {
    const actionData = { action: GET_AUDIT_BREAKDOWN_INFO }
    const {requestId} = context.state
    context.commit(SET_FEED_AUDIT_LOADING, {status: true, requestId})
    return new Promise((resolve, reject) => {
      getFeedBreakdownAuditInfo(context, actionData)
        .then(result => {
          let data = {
            breakdownAuditInfos: result.data
          }
          context.commit(SET_AUDIT_BREAKDOWN_INFO, data)
          context.commit(SET_FEED_AUDIT_LOADING, {status: false, requestId})
          resolve(data)
        })
        .catch((err) => {
          console.error('Error fetching audit records for feed', err)
          reject(err)
        })
    })
  },
  [GET_FEED_ERROR_DETAILS] ({rootState, commit, dispatch}, requestId) {
    commit(SET_FEED_ERROR_DETAILS_LOADING, true)
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/connect/feed/error/${requestId}`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: GET_FEED_ERROR_DETAILS}
    })
      .then((res) => {
        commit(SET_FEED_ERROR_DETAILS, res.data)
        commit(SET_FEED_ERROR_DETAILS_LOADING, false)
      })
      .catch((err) => {
        console.log(`Errored while trying to fetch feed error details`)
        console.error(err)
      })
  },
  [DOWNLOAD_FEED_ERROR] ({rootState, commit, dispatch}, requestId) {
    commit(FEED_REPORT_LOADING, true)
    commit(FEED_REPORT_LOADING_LABEL)
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/report/feed/errors/${requestId}`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: DOWNLOAD_FEED_ERROR}
    })
      .then((res) => {
        let pollingFrequency = rootState.config.reportPollingDuration / rootState.config.reportPollingFrequency
        let pollingCount = 1
        dispatch(CHECK_IF_FEED_REPORT_AVAILABLE, {pollingFrequency: pollingFrequency, pollingCount: pollingCount, reportId: res.data})
      })
      .catch((err) => {
        console.log(`Error while trying to download feed error details`)
        console.error(err)
      })
  },
  [CHECK_IF_FEED_REPORT_AVAILABLE] ({commit, dispatch, rootState, state}, reportObject) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/report/available/${reportObject.reportId}`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: CHECK_IF_FEED_REPORT_AVAILABLE}
    })
      .then((res) => {
        if (!res.data && reportObject.pollingCount !== reportObject.pollingFrequency) {
          let pollingTimeout = rootState.config.reportPollingFrequency
          setTimeout(() => {
            dispatch(CHECK_IF_FEED_REPORT_AVAILABLE, {pollingFrequency: reportObject.pollingFrequency, pollingCount: reportObject.pollingCount + 1, reportId: reportObject.reportId})
          }, pollingTimeout)
        } else {
          dispatch(DOWNLOAD_FEED_ERROR_REPORT_CSV, reportObject.reportId)
        }
      }).catch((err) => {
        console.log('Failed to check my student report availability')
        console.error(err)
      })
  },
  [DOWNLOAD_FEED_ERROR_REPORT_CSV] ({commit, rootState, state}, reportId) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/report/download/${reportId}`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: DOWNLOAD_FEED_ERROR_REPORT_CSV},
      responseType: 'blob'
    }).then(res => {
      const name = `Feed Errors.csv`
      FileSaver.saveAs(res.data, name)
      commit(FEED_REPORT_LOADING, false)
      commit(FEED_REPORT_FINISHED_LABEL)
    }).catch(err => {
      console.error(err)
      console.log(`Failed to download the feed errors`)
      commit(FEED_REPORT_LOADING, false)
      commit(FEED_REPORT_FINISHED_LABEL)
    })
  },
  [STORE_FEED_BREAKDOWN_AUDIT_ID] ({commit}, requestId) {
    commit(SET_FEED_BREAKDOWN_AUDIT_ID, requestId)
  },
  [LOAD_FEED_SCHEDULE_ID] (context, scheduleId) {
    context.commit(SET_FEED_SCHEDULE_ID, scheduleId)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/feedsModule.js